import React, { memo, useCallback, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import styles from './Update.module.less';
import { PCStoreJsBridge } from '../../../nativeapi';
import Toast from '../../../components/Toast/Toast';
import { logging } from '../../../actions/log';

import { cacheKeys } from '../../../constants/storageKeys';
import { localSetItem } from '../../../utils/utils';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(() => {
  const dispatch = useDispatch();
  const [controlInfo, setControlInfo] = useState({});

  const logInfoData = useSelector(selectLogInfo);

  const handleChoose = useCallback(
    info => {
      const startInfo = JSON.parse(localStorage.getItem(cacheKeys.START_INFO) || '{}');
      PCStoreJsBridge.settingRightMenu({
        enable: startInfo.rightMenuInfo.enable,
        source: 1,
        wallpaperEnable: !info.wallpaperEnable,
        recommendEnable: startInfo.rightMenuInfo.recommendEnable,
      }).then(res => {
        if (res.succ === 'true') {
          setControlInfo({
            wallpaperEnable: !info.wallpaperEnable,
            cloudEnable: info.cloudEnable,
            recommendEnable: info.recommendEnable,
          });
          let Info = {
            ...startInfo,
            rightMenuInfo: {
              enable: startInfo.rightMenuInfo.enable,
              source: 1,
              wallpaperEnable: !info.wallpaperEnable,
              recommendEnable: startInfo.rightMenuInfo.recommendEnable,
              cloudEnable: true,
            },
          };
          localStorage.setItem('START_INFO', JSON.stringify(Info));
          Toast.success({
            content: '设置成功!',
          });
        }
      });

      dispatch(
        logging({
          category: 'C',
          action: 'Tankuang_Enabled',
          label: '',
          param2: {
            source: 'Setting',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            enabled: !info.wallpaperEnable,
            type: 7,
          },
        }),
      );
    },
    [controlInfo],
  );

  // 修改未知文件设置的默认值
  useEffect(() => {
    PCStoreJsBridge.getRightMenuInfo().then(res => {
      if (res.succ) {
        setControlInfo(res);
      }
    });
  }, []);

  return (
    <div className={styles.s_update}>
      {controlInfo && controlInfo.cloudEnable && (
        <div className="s_line">
          <div className="s_select_title">壁纸中心设置:</div>
          <div className="s_content">
            <div className="checkbox checkbox_clear" onClick={() => handleChoose(controlInfo)}>
              {controlInfo.wallpaperEnable ? (
                <div className="checked" />
              ) : (
                <div className="no_checked" />
              )}
              <span>开启壁纸中心入口</span>
            </div>
            <div className="desc desc_margin_top">壁纸换一换，心情好一半</div>
          </div>
        </div>
      )}
    </div>
  );
});
